import { useState } from 'react';
import { imageUrl, formatDate } from './posts';
import './Aktuelles.css';

// Ab dieser Textlänge wird gekürzt und „Weiterlesen" angeboten
const CLAMP_THRESHOLD = 180;

function PostCard({ post }) {
  const [isExpanded, setExpanded] = useState(false);
  const isLong = post.text && post.text.length > CLAMP_THRESHOLD;

  return (
    <article className="aktuelles__card">
      {post.image && (
        <div className="aktuelles__image-wrap">
          <img
            src={imageUrl(post.image)}
            alt={post.title}
            className="aktuelles__image"
            loading="lazy"
          />
        </div>
      )}
      <div className="aktuelles__card-body">
        <time className="aktuelles__date" dateTime={post.publishedAt}>
          {formatDate(post.publishedAt)}
        </time>
        <h3 className="aktuelles__card-title">{post.title}</h3>
        <p className={`aktuelles__text${isLong && !isExpanded ? ' aktuelles__text--clamped' : ''}`}>
          {post.text}
        </p>
        {isLong && (
          <button
            className="aktuelles__readmore"
            onClick={() => setExpanded(!isExpanded)}
            aria-expanded={isExpanded}
          >
            {isExpanded ? 'Weniger anzeigen' : 'Weiterlesen'}
          </button>
        )}
        {post.link && (
          <a
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
            className="aktuelles__link"
          >
            Mehr erfahren <span className="aktuelles__link-arrow">→</span>
          </a>
        )}
      </div>
    </article>
  );
}

export default PostCard;
